import { mapActions } from "vuex";

export default  {
	created () {    
	   
	},
	methods: 
    {	
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async actualizarFtn()
		{
			try{

			}catch{

			}
		},
		async saveForm(event)
		{
			try{
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'afiliacionFtn': 
							await this.updateDataForm({state: 'afiliacion_registro', data: { id: this.dataForm[this.namePath].afiliacion_registro.id, id_info_ingresos: null}})

							let servicios_nuevos=[]							
							for (let i = 0; i < this.dataForm[this.namePath].servicios_nuevos.length; i++) {
								servicios_nuevos.push({ id: this.dataForm[this.namePath].servicios_nuevos[i].id, id_info_ingresos: null})								
							}
							await this.updateDataForm({state: 'servicios_nuevos', data: servicios_nuevos})
							
							let servicios_activos=[]							
							for (let i = 0; i < this.dataForm[this.namePath].servicios_activos.length; i++) {
								servicios_activos.push({ id: this.dataForm[this.namePath].servicios_activos[i].id, id_info_ingresos: null})								
							}
							await this.updateDataForm({state: 'servicios_activos', data: servicios_activos})

							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_all', 
									tablaAuditar: true, 
									notaDelete: null, 
									tablaPost: ['info_ingresos','servicios_activos','servicios_nuevos','afiliacion_registro'],
									tablaDelete:[]
								}
							}) 
						break; 	
						case 'anularAfiliacionFtn':
							await this.updateDataForm({state: 'datos_afiliado', data: { id: this.dataForm[this.namePath].info_afiliacion.id_datos_afiliado, id_list_estado: 2 }})
							await this.updateDataForm({state: 'info_ingresos/anulado', data: 1})
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_all', 
									tablaAuditar: true, 
									notaDelete: this.dataForm[this.namePath].info_afiliacion.nota_delete, 
									tablaPost: ['info_afiliacion','info_ingresos','servicios_activos','servicios_nuevos','afiliacion_registro','datos_afiliado'],
									tablaDelete:['info_afiliacion','info_ingresos','servicios_activos','servicios_nuevos',]
								}
							}) 
							 
						break;
					}
				}

				await this.save(event.save)
				

				await this.getDataGet({route: 'get_aflinformes', data: {inicial: this.filter.inicial, final:  this.filter.final, others: []}})
				//frontend await this.searchIdb({tabla:'servicios_nuevos',campo:'iniciolabores',value:'',principal:'info_afiliacion'})

				const await10 =  this.resetDataIndex()
				const await11 =  this.resetGlobal({state: 'openModal'})
				const await12 =  this.resetDataForm()
				const await13 =  this.resetGlobal({state: 'saveConfig/capa'}) 
				await await10
				await await11
				await await12
				await await13
			}
			catch{

			}			
		}		
	},
}
